// extracted by mini-css-extract-plugin
export default {"highlightedText":"highlightedText-module__highlightedText__pgwfS","highlightedTextCapitalize":"highlightedText-module__highlightedTextCapitalize__Kq0gp"};